import { render } from "./TransferReceipt.vue?vue&type=template&id=4593e841"
import script from "./TransferReceipt.vue?vue&type=script&lang=js"
export * from "./TransferReceipt.vue?vue&type=script&lang=js"

import "./TransferReceipt.vue?vue&type=style&index=0&id=4593e841&lang=less"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__